// @generated da scripts/i18n-sr-cyrl.mjs — NON EDITARE A MANO.
// i18n area 'storage' — locale sr-Cyrl-RS: TRASLITTERAZIONE MECCANICA
// di storage.sr-Latn-RS.ts (srpska latinica). Ogni modifica va fatta
// sulla locale sr-Latn-RS e poi rigenerata con: node scripts/i18n-sr-cyrl.mjs
// Sidecar anti-stantie: ../meta/storage.sr-Cyrl-RS.meta.json.
import type { enUS } from './storage'

export const srCyrlRS: typeof enUS = {
  storage: {
    pools: {
      title: 'Storage',
      createTitle: 'Креирајте storage',
      path: 'Путања',
      pathHint: 'Апсолутна путања под дозвољеним rootom (подразумевано /var/lib/tvirt/pools/)',
      shared: 'Дељени storage',
      sharedChip: 'дељено',
      sharedVerifiedChip: 'дељено · проверено',
      sharedVerifiedTooltip: 'Дељење проверено: унакрсне сонде потврђују да сваки члан види податке које су уписали други.',
      sharedDisputedChip: 'дељено · НИЈЕ проверено',
      sharedDisputedTooltip: 'Дељење НИЈЕ проверено',
      sharedDisputedPair: '{observer} не види податке које је уписао {writer}',
      sharedHint: 'Мрежни share монтиран локално на истој путањи на сваком члану — предуслов live миграције (декларативно).',
      sharedDanger: 'ОПАСНОСТ — TVirt ВЕРУЈЕ овом flagu: када га укључите, сваки члан претпоставља да на овој путањи види ИСТЕ бајтове. На фасцикли која НИЈЕ заиста дељени share (NFS/CIFS/кластерски filesystem) резултат је оштећење и губитак података при првој миграцији или првом HA restartu на другом чвору. Укључите га само ако је путања share монтиран идентично на сваком чвору.',
      type: 'Тип',
      capacity: 'Капацитет',
      provisioned: 'Алоцирано',
      provisionedOvercommit: 'Потенцијална обавеза изнад капацитета: thin волумени могу нарасти до {n} GiB.',
      phase: { ready: 'Спреман', degraded: 'Деградиран', error: 'Грешка' },

      // Round #156 (dialog standard): il dialog dettagli COMPLETO — tab,
      // le righe di config per-driver e la superficie osservata.
      tabConfig: 'Конфигурација',
      tabCapacity: 'Капацитет и стање',
      cardIdentity: 'Идентитет',
      cardPlacement: 'Смештај',
      cardConnection: 'Конекција',
      usedReal: 'Стварна заузетост',
      capacityUnknown: 'Чвор још није пријавио капацитет овог poola — овде се бројеви не измишљају',
      overcommitHint: 'Обавеза изнад капацитета: легитимно на thin poolovima, пратите стварну заузетост',
      supportedContent: 'Подржани садржаји',
      content: {
        disks: 'Дискови',
        catalogFiles: 'Датотеке каталога',
        backups: 'Бекапи',
        appVolumes: 'Волумени апликација'
      },
      defaultDiskFormat: 'Подразумевани формат диска',
      reserveGiB: 'Резервисан слободан простор (GiB)',
      available: 'Доступно',
      diskCount: 'Дискови',
      filesystem: 'Filesystem',
      observedAt: 'Посматрано',
      lostAtRow: 'Проглашено изгубљеним',
      sharedProbeRow: 'Провера дељења',
      sharedProbeNodes: 'Сондирани чворови',
      reachableFrom: 'Декларисана доступност',
      reachableFromHint: 'Чворови са којих овај storage мора бити доступан. VM чији дискови, ISO-и или метаподаци живе овде не покреће се нити мигрира на чвор ван ове листе. Сви чланови су унапред изабрани — сузите по жељи. Чвор који касније уђе у кластер остаје ван док га овде не додате.',
      reachableFromNone: 'није декларисана',
      reachableFromTags: 'Доступност по таговима',
      reachableFromTagsHint: 'Селектор таг=вредност (ставке одвојене зарезима, у AND-у): сваки члан који носи ове тагове декларисан је као доступан — динамички: таговање чвора га уводи.',
      reachableFromTagsInvalid: 'Неисправан формат — користите таг=вредност, одвојено зарезима',
      reachableResolved: 'Разрешени чворови: {nodes}',
      reachableDeclaredNotSeen: 'декларисано, али не и виђено сондом дељења на: {nodes}',
      reachableSeenNotDeclared: 'виђено, али не и декларисано (ван периметра) на: {nodes}',
      cephCluster: 'Управљани Ceph кластер',
      appGuardTitle: 'Storage који користе апликације',
      appEphemeralGuard: 'овај storage је кластерски ефемерни pool апликација — најпре га промените на страници Апликације, па га онда обришите.',
      appInUseGuard: 'овде живе rootovi/волумени апликација: {apps} — најпре их преместите или обришите.',
      releaseRequiredTitle: "Обрисати '{name}' и ослободити његове слике?",
      releaseRequiredBatchTitle: 'Обрисати изабране storage и ослободити њихове слике?',
      releaseRequiredBody: 'Ослобађање слика не брише НИЈЕДАН бајт: одјава оставља namespace на диску, слике једноставно престају да буду материјализоване, а свака референца scope-ова преживљава као claim — поново региструјте pool и биће поново усвојене.',
      releaseConfirm: 'Обриши и ослободи слике'
    },
    lost: {
      chip: 'Изгубљен',
      action: 'Прогласи изгубљеним',
      confirmTitle: 'Прогласите storage изгубљеним',
      confirmBody: 'Атестација оператера на сопствени декларисани ризик: сваки задатак у реду чекања или у току који циља овај storage или његове објекте биће НЕУСПЕШАН, брисања постају само запис у евиденцији (без рада на filesystemu), а нови физички рад се одбија. Бајтови се никада не дирају — ако се волумен врати у живот, региструјте га поново и покрените скенирање да бисте све поново усвојили.',
      confirmSubmit: 'Прогласи изгубљеним',
      error: 'Атестација је одбијена'
    },
    findings: {
      action: 'Пронађени објекти',
      title: 'Пронађени објекти',
      empty: 'Ниједан објекат није пронађен у storage namespaceu',
      loadError: 'Пронађене објекте није могуће учитати',
      actionError: 'Одлука је одбијена',
      colKind: 'Тип',
      colObject: 'Објекат',
      colConflict: 'Конфликт',
      namespaceNotice:
        'Овај директоријум је већ иницијализовало друго складиште: печат идентитета преписан је печатом овог складишта. Садржај НИЈЕ диран — погледај пронађене објекте испод, увези оне који су ти потребни, па затвори ово обавештење.',
      kind: {
        disk: 'Диск',
        catalogFile: 'Датотека каталога',
        vmMetadata: 'VM метаподаци',
        namespace: 'Namespace',
        foreign: 'Страно',
        volumeGroup: 'Група волумена'
      },
      vgAdopt: {
        action: 'Усвоји групу волумена',
        title: 'Усвоји групу волумена',
        intro:
          'Овај уређај већ носи групу волумена са именом TVirta, али њен печат не именује ниједан овде регистрован storage. Може бити оно што је претходни storage OVOG кластера оставио на LUN-у — или оно што је DRUGI TVirt кластер оставио на LUN-у који је променио власника: одавде оба случаја изгледају исто, и зато нико не одлучује уместо вас.',
        irreversible: 'Погледајте уређај, печат и име пре него што наставите: усвајање се не поништава.',
        device: 'Уређај',
        seal: 'Печат',
        sealNone: 'нема (нема ознаке tvirt.storageId)',
        renameTo: 'Биће преименована у',
        renameNone: 'Без преименовања: име је већ оно које овај storage изводи',
        volumesNote:
          'Садржани волумени се овим гестом НЕ усвајају: следеће скенирање их нуди један по један, као обичне пронађене објекте.'
      },
      conflictChip: 'ID већ постоји',
      dismissedChip: 'Игнорисано',
      adopt: 'Усвоји',
      adoptFileTitle: 'Увезите у каталог',
      adoptFileHint: 'Датотеке постоје само унутар каталога: изаберите одредишни каталог за пронађену датотеку.',
      purge: 'Обриши са диска',
      dismiss: 'Игнориши',
      purgeConfirmTitle: 'Обришите са диска',
      purgeConfirmBody: 'Пронађени бајтови објекта {id} биће уклоњени са storagea. Операција је неповратна.',
      taskStarted: 'Покренуто — наставља се као задатак у позадини',
      scan: 'Скенирај storage',
      scanStarted: 'Скенирање покренуто…',
      scanDone: 'Скенирање завршено — пронађени објекти су ажурирани'
    },
    reinit: {
      action: 'Поново покушај иницијализацију'
    },
    wizard: {
      addButton: 'Додај',
      title: 'Додајте storage',
      back: 'Назад',
      continue: 'Настави',
      selectHint: 'Изаберите протокол да бисте видели како га TVirt користи.',
      roadmap: 'Roadmap',
      server: 'Сервер',
      export: 'Експортована путања',
      share: 'Share',
      username: 'Корисничко име',
      password: 'Лозинка',
      passwordHint: 'Само за упис: користи се за mount, никада се више не приказује.',
      credential: 'Акредитив',
      credentialManual: 'Унеси ручно',
      credentialHint: 'Ставка keystorea типа корисничко име и лозинка — алтернатива њиховом укуцавању овде.',
      credentialEmpty: 'У keystoreu нема акредитива типа корисничко име и лозинка — креирајте га у Систем → Акредитиви, или укуцајте налог испод.',
      options: 'Mount опције',
      optionsHint: 'Одвојене зарезом, прослеђују се mount -о дословно.',
      portal: 'Портал',
      portalHint: 'хост[:порт] — подразумевани порт је 3260.',
      target: 'Target IQN',
      targetHint: 'Име iSCSI targeta, почиње са iqn.',
      lun: 'LUN',
      wholeLunRow: 'На дисковима: овај storage именује само target',
      wholeLunHint: 'Овај storage именује само target: његови LUN-ови постају дискови један по један (Направи диск → преузми цео LUN), на target се ништа не пише.',
      lunHint: 'Број LUN-а на targetu — 0 ако нисте сигурни.',
      chapCredential: 'Акредитив (CHAP)',
      chapCredentialHint: 'Ставка keystorea типа CHAP (iSCSI) која се користи за login — тајна никада не путује уз storage.',
      chapNone: 'Без аутентификације',
      chapEmpty: 'У keystoreu нема акредитива типа CHAP (iSCSI) — креирајте га у Систем → Акредитиви. Без њега login остаје неаутентификован.',
      address: 'Адреса',
      addressHint: 'Хост или IP NVMe/TCP targeta (traddr).',
      port: 'Порт',
      portHint: 'TCP порт targeta — 4420 ако се остави празно.',
      targetNqn: 'Target NQN',
      targetNqnHint: 'NQN subsystema на targetu, почиње са nqn.',
      nsid: 'NSID',
      nsidHint: 'Namespace ID унутар subsystema — 1 ако нисте сигурни.',
      dhchapCredential: 'Акредитив (DH-HMAC-CHAP)',
      dhchapCredentialHint: 'Ставка keystorea типа DH-HMAC-CHAP (NVMe) која се користи при повезивању — тајна никада не путује уз storage.',
      dhchapNone: 'Без аутентификације',
      dhchapEmpty: 'У keystoreu нема акредитива типа DH-HMAC-CHAP (NVMe) — креирајте га у Систем → Акредитиви. Без њега конекција остаје неаутентификована.',
      monitors: 'Монитори',
      monitorsHint: 'Endpointi Ceph монитора, хост[:порт], одвојени зарезом или новим редом — подразумевани порт 6789.',
      pool: 'Pool',
      poolHint: 'RBD pool који се користи — једна RBD слика по диску.',
      fs: 'Filesystem',
      fsHint: 'Име CephFS filesystema (mds_namespace при mountu).',
      fsPath: 'Путања унутар filesystema',
      fsPathHint: 'Апсолутна путања унутар filesystema који storage монтира — / ако сте у недоумици.',
      cephxCredential: 'Акредитив (cephx)',
      cephxCredentialHint: 'Ставка keystorea типа cephx: username = име клијента (client.…), secret = base64 кључ. Обавезна.',
      cephxNone: 'У keystoreu нема cephx акредитива — креирајте један (тип: cephx) у Систем → Акредитиви, или пустите да га управљани Ceph кластер искује кроз „Предложи као storage“.',
      sharedByNature: 'Storage преко мреже је по природи дељен: сваки члан га монтира на истој путањи којом управља TVirt.',
      error: 'Storage је одбијен',
      category: {
        nas: 'NAS',
        san: 'SAN',
        ceph: 'Ceph',
        other: 'Остало',
        legacy: 'Legacy'
      },
      legacyHint: 'Подржани у потпуности — само их не бисмо изабрали за нову инсталацију.',
      proto: {
        // La riga `usage` (Luca 2026-07-24) dice come TVirt usa il protocollo —
        // in primis i contenuti ammessi: dir/nfs/cifs ospitano dischi E immagini
        // ISO/disco e template, i driver a blocchi (iscsi/nvme-tcp/rbd) SOLO
        // dischi.
        dir: {
          name: 'Локална фасцикла',
          desc: 'Директоријум на чвору: једноставно и брзо. ЛОКАЛАН је за један чвор, осим ако путања није заиста дељени share — означити га као дељен кад није кошта података.',
          usage: 'TVirt у њему чува дискове VM-ова, ISO/диск слике и шаблоне.'
        },
        nfs: {
          name: 'NFS',
          desc: 'NFS експорт који кластер монтира — дељен по природи.',
          usage: 'Држи дискове VM-ова, ISO/диск слике и шаблоне.'
        },
        cifs: {
          name: 'CIFS/SMB',
          desc: 'Windows/Samba share који кластер монтира — дељен по природи.',
          usage: 'Држи дискове VM-ова, ISO/диск слике и шаблоне.'
        },
        sftp: {
          name: 'SFTP',
          desc: 'Удаљени filesystem преко SSH — без потребе за NAS експортом.',
          usage: 'У roadmapu.'
        },
        iscsi: {
          name: 'iSCSI',
          desc: 'Блок LUN-ови преко IP-а са дељеним LVM-ом поврх.',
          usage: 'Само дискови — један thin волумен по диску; не држи ISO слике ни шаблоне.'
        },
        rbd: {
          name: 'Ceph RBD',
          desc: 'Дистрибуирани блок уређаји на Ceph кластеру.',
          usage: 'Само дискови — једна RBD слика по диску, коју QEMU отвара нативно; не држи ISO слике.'
        },
        cephfs: {
          name: 'CephFS',
          desc: 'Дистрибуирани Ceph filesystem, који кернел монтира на кластеру — shared by nature.',
          usage: 'Држи VM дискове, ISO/диск слике и шаблоне — породица dir на Ceph filesystemu (cephx акредитив обавезан).'
        },
        fc: { name: 'SCSI/FC', desc: 'SCSI LUN-ови преко FibreChannel fabrica — класични FC SAN.' },
        fcoe: { name: 'SCSI/FCoE', desc: 'Исти SCSI преко FibreChannela, са FC фрејмовима енкапсулираним у Ethernet.' },

        // Vivo dal round #132 — la chiave è il nome del driver del contract,
        // così il chip della lista storage risolve la stessa voce.
        'iscsi-lun': {
          name: 'iSCSI (цели LUN-ови)',
          desc: 'iSCSI target као носилац целих LUN-ова: сваки диск ЈЕСТЕ LUN, сирово предат госту — без LVM-а између.',
          usage: 'Само дискови — један цео LUN по диску, преузет какав јесте; SAN дом дискова са дељеним писањем.'
        },
        'nvme-tcp-lun': {
          name: 'NVMe/TCP (цели namespace-ovi)',
          desc: 'NVMe подсистем као носилац целих namespace-ова: сваки диск ЈЕСТЕ namespace, сирово предат госту.',
          usage: 'Само дискови — један цео namespace по диску, преузет какав јесте; дељено писање да, SCSI персистент ресерватионс не.'
        },
        'nvme-tcp': {
          name: 'NVMe/TCP',
          desc: 'Удаљени NVMe — без SCSI-ја у путањи — преко обичног TCP-а, са дељеним LVM-ом поврх.',
          usage: 'Само дискови — један thin волумен по диску; не држи ISO слике ни шаблоне.'
        },
        nvmefc: { name: 'NVMe/FC', desc: 'Удаљени NVMe преко FibreChannel fabrica.' },
        nvmefcoe: { name: 'NVMe/FCoE', desc: 'NVMe преко FibreChannel fabrica који FCoE преноси унутар Etherneta — слојеви FCoE и NVMe/FC наслагани.' },
        iser: { name: 'iSCSI/RDMA (iSER)', desc: 'iSCSI са путањом података премештеном на RDMA — било који fabric (InfiniBand, iWARP, RoCE). Превазиђен од стране NVMe/RDMA, и даље присутан у arrayima и у ESXi-ју.' },
        srp: { name: 'SCSI/RDMA (SRP)', desc: 'Нативни SCSI преко RDMA, ера пре iSER-а: InfiniBand (уз fabric discovery) и RoCE — преживљава у застарелом HPC storageu.' },
        nvmerdma: { name: 'NVMe/RDMA', desc: 'Удаљени NVMe преко било ког RDMA fabrica — InfiniBand, iWARP, RoCE v1 и v2: једна конфигурација, а чвор јавља који има.' },
        s3: { name: 'S3', desc: 'S3-компатибилан object storage — слике и резервне копије.' }
      }
    },
    catalogs: {
      title: 'Каталози',
      createTitle: 'Креирајте каталог',
      editTitle: 'Измените каталог',
      docTitle: 'Каталог',
      notFound: 'Овај каталог (више?) не постоји',
      scopeHint: 'Ко чита овај scope види (и може да користи) сваку датотеку каталога',
      files: 'Датотеке',
      noFiles: 'Нема датотека',
      count: {
        iso: 'ISO',
        ctRootfs: 'CT tpl',
        vmTemplate: 'VM tpl',
        ociImage: 'OCI',
        firmwareOvmf: 'Firmware'
      },

      // Il catalogo di sistema (round #126): la casa degli oggetti integrati
      // della piattaforma — leggibile da tutti, scrivibile da nessuno.
      systemChip: 'системски',
      systemTooltip: 'Системски каталог: држи уграђене објекте платформе и не може се мењати'
    },

    // File di catalogo (round K1, inventory v2e/v2g): il catalogo è la casa
    // degli artefatti file del cluster — una lista, titoli per kind.
    catalogFiles: {
      catalog: 'Каталог',
      kindLabel: 'Тип',
      physicalSize: 'Физичка величина',
      virtualSize: 'Виртуелна величина',

      // Round K3 (#64) + K4 (#65, ova/ovf con la mappatura boot-survival):
      // materializza un file vm-template come VM Template dell'inventario.
      importTemplateAction: 'Увези као VM шаблон',
      importTemplateLegacy: 'Нема декларисаног формата — употребљиво као seed за дискове, не може се увести',
      importTemplateTitle: 'Увезите као VM шаблон',
      importTemplateSubmit: 'Увези',
      importTemplateError: 'Увоз није успео',
      importTemplateHint: 'Пакет .tvtpl постаје VM шаблон: замрзнути хардвер из manifesta плус један диск по ставци архиве, сваки проверен у односу на свој checksum. NIC-ови и CD/DVD медији нису део архиве — додајте их после увоза.',
      importTemplateQcow2Hint: 'Голи qcow2 постаје шаблон са ЈЕДНИМ диском и декларисаним подразумеваним хардвером: профил linux, UEFI, 2 vCPU, 2048 MiB, boot са његовог јединог диска. Подесите при deployu.',
      importTemplateName: 'Име шаблона',
      importTemplateNameHint: 'Празно = {name} (-import-<n> ако је заузето)',
      importTemplateStorage: 'Storage за дискове',
      importTemplateMetadataStorage: 'Storage метаподатака',
      importTemplateMetadataHint: 'Блок storage не држи VM метаподатке (firmware, varstore) — изаберите неки dir/nfs/cifs.',
      importTemplateStarted: 'Увоз покренут — шаблон се појављује у табу Шаблони по завршетку задатка.',

      // Etichette parlanti al singolare (#86): findings e censimento dicono
      // COSA è il file — il generico 'File di catalogo' resta solo fallback.
      kind: {
        iso: 'ISO слика',
        'ct-rootfs': 'CT rootfs',
        'vm-template': 'VM шаблон',
        'oci-image': 'OCI слика',
        'firmware-ovmf': 'OVMF firmware'
      },
      title: {
        iso: 'ISO слике',
        'ct-rootfs': 'CT шаблони',
        'vm-template': 'VM шаблони',
        'oci-image': 'OCI слике',
        'firmware-ovmf': 'OVMF firmware'
      },
      createTitle: {
        iso: 'Додајте ISO слику',
        'ct-rootfs': 'Региструјте CT шаблон',
        'vm-template': 'Додајте VM шаблон',
        'oci-image': 'Додајте OCI слику',
        'firmware-ovmf': 'Додајте OVMF firmware'
      },
      formatHint: 'Изведено из екстензије изабране датотеке — исправите ако је погрешно погодило',
      tarballHint: 'Rootfs tarball у стандардном LXC формату (.tar.gz / .tar.xz / .tar.zst / .tar.bz2, или обичан .tar)',
      ociArchiveHint: 'Tarball docker-archive / oci-archive (.tar или .tar.gz), на пример из docker save',
      uploadResumeHint: 'Upload прекинут — датотека чека upload: пошаљите поново исту датотеку да бисте наставили',
      moveTitle: 'Преместите датотеку',
      moveHint: 'Две независне димензије: Каталог премешта везу (исти id, ниједан бајт се не помера, scope постаје онај одредишног каталога); Storage премешта податке — свака повезана копија је прати, одбија се док је датотека у употреби. Изабрани заједно: прво каталог, па storage.',
      moveCatalog: 'Одредишни каталог',
      moveCatalogHint: 'Само веза мења дом: VM која је монтирала датотеку мора да види одредишни каталог',
      keepCurrent: 'Не мењај',
      rehomed: 'Веза премештена у изабрани каталог',
      copyAction: 'Копирај у каталог…',
      copyTitle: 'Копирајте у каталог',
      copyLinkHint: 'Копија је нова веза ка истим подацима — ништа се не дуплира на storageu.',
      copyCatalog: 'Одредишни каталог',
      copyCatalogHint: 'Копирање је начин на који датотека путује између каталога',
      sameCatalog: 'Исти као извор',
      sharedObjectHint: 'Подаци ове датотеке су дељени — повезаних копија: {count}',
      deleteLastLink: 'Ово је ПОСЛЕДЊА веза ка овом садржају: биће обрисани и подаци са storagea.',
      deleteLinkOnly: 'Биће уклоњена само ова веза — подаци остају, и даље доступни кроз остале повезане копије ({count}).',
      noCatalog: 'Још нема ниједног каталога — креирајте један',
      inlineCatalogName: 'Име каталога',

      // File integrati nella piattaforma (round #126): storage null — si
      // leggono e si clonano, mai move/delete/rename.
      embeddedChip: 'уграђено',
      embeddedStorage: 'Уграђено у платформу',
      embeddedNoMove: 'Уграђена датотека платформе: не живи ни на једном storageu — уместо тога је клонирајте',
      embeddedCopyHint: 'Клон материјализује уграђене бајтове на прави storage: изаберите одредишни storage и каталог — копија је обична датотека',
      sourceEmbedded: 'Уграђено у платформу',
      nodesRow: 'Присуство по чвору',
      nodesSummary: '{present} од {total} чворова га има',
      nodePresent: 'присутан',
      nodeMissing: 'недостаје',
      nodeUnknown: 'још није пријављено',
      nodesHint: 'Асет живи на диску сваког чвора (пакет trantor-tvirt-assets): чвор који га нема не може ни да дефинише VM са овим фирмвером ни да служи Guest Tools. Различите верзије међу чворовима су нормалне током постепеног ажурирања.',

      // Download (round #108): i byte viaggiano col loro permesso dedicato.
      downloadAction: 'Преузми',
      downloadNotReady: 'Садржај још није спреман — download захтева датотеку у стању ready',
      downloadDenied: 'Ваша улога не укључује catalog.download — преузимање бајтова је право одвојено од употребе датотеке',

      // Round #156 (dialog standard): le righe di lettura mancanti del dialog
      // dettagli — i fatti dell'oggetto condiviso, il checksum dichiarato, gli
      // utilizzatori.
      objectRow: 'Storage објекат',
      objectLinksRow: 'Повезане копије',
      declaredChecksum: 'Декларисани SHA-256',
      usedByRow: 'Користе га',
      usedByVms: 'VM-ови',
      usedByDisks: 'Дискови',
      transferRow: 'Пренос',
      storageLockHint: 'Мења се само акцијом Премести'
    },

    // Il censimento per-storage (round K1, inventory v2b #2): sola lettura,
    // ogni oggetto si gestisce dalla sua sezione.
    objects: {
      action: 'Истражи садржај',
      title: 'Садржај storagea',
      hint: 'Попис само за читање онога што живи на овом storageu — сваким објектом се управља из његове секције.',
      empty: 'Ниједан објекат није регистрован на овом storageu',
      loadError: 'Садржај није могуће учитати',
      colDetail: 'Детаљ',
      manage: 'Управљај у његовој секцији',
      kind: {
        disk: 'Диск',
        catalogFile: 'Датотека каталога',
        ociBlob: 'OCI blob',
        checkpoint: 'Checkpoint',
        vmMetadata: 'VM метаподаци',
        appRoot: 'Root апликације',
        appVolume: 'Волумен апликације'
      }
    },
    inventory: {
      tabCatalogs: 'Каталози',
      storage: 'Storage',
      sizeGib: 'Величина (GiB)',
      format: 'Формат',
      size: 'Величина',
      sourceType: 'Извор',
      sourceFile: 'Отпремање датотеке',
      sourceUrl: 'Download са URL-а',
      file: 'Датотека',
      url: 'URL',
      checksum: 'SHA-256 checksum',
      checksumHint: 'Обавезно: download се проверава у односу на овај SHA-256',
      verifyChecksum: 'Провери checksum',
      checksumOffHint: 'Download ће бити прихваћен без провере — израчунати SHA-256 се свеједно бележи',
      uploading: 'Отпремање…',
      move: {
        action: 'Премести',
        diskTitle: 'Преместите диск',
        target: 'Одредишни storage',
        diskHint: 'Диск задржава свој идентитет: бајтови путују на изабрани storage. VM који га користи мора бити угашен; уз присутне снимке iSCSI страна одбија премештање.',
        noTargets: 'Нема компатибилног одредишног storagea',
        submit: 'Премести',
        error: 'Премештање је одбијено'
      },
      clone: {
        action: 'Клонирај',
        title: 'Клонирајте диск',
        name: 'Име копије',
        storage: 'Одредишни storage',
        sameStorage: 'Исти као извор',
        linked: 'Linked clone',
        linkedHint: 'Тренутни qcow2 overlay уланчан на изворни диск (само qcow2 извори). Подразумевано је пуна копија.',
        linkedCrossHint: 'Linked clone остаје на storageu извора: изаберите „Исти као извор“ да бисте га омогућили.',
        submit: 'Клонирај',
        error: 'Клонирање је одбијено'
      },
      copy: {
        action: 'Копирај',
        name: 'Име копије',
        storage: 'Одредишни storage',
        sameStorage: 'Исти као извор',
        submit: 'Копирај',
        error: 'Копирање је одбијено'
      },
      taskStarted: 'Покренуто — наставља се као задатак у позадини',
      cephObjects: 'Иди на детаље објекта на Cephu',
      phase: {
        ready: 'Спремна',
        creating: 'У креирању',
        'awaiting-upload': 'Чека upload',
        downloading: 'У преузимању',
        verifying: 'У провери',
        deleting: 'Брише се',
        error: 'Грешка',
        'in-use': 'У употреби'
      }
    }
  }
}
